import { DataTable, Heading, Loader } from "@/components";
import usePredefined from "./usePredefined";

const Predefined = () => {
    const {breadcrumbData, onBackClick, globalFilter,
      setGlobalFilter,
      columns, predefinedTemplateList,
      isTemplateLoading} = usePredefined();
  
      return (
      <div className="p-4 md:p-6">
          {/* Header & Search */}
          <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
            <div className="flex flex-row items-center justify-between">
              <Heading
                title={`Predefined Templates`}
                breadcrumbData={breadcrumbData}
                onBackClick={onBackClick}
              />
            </div>
          </div>
  
        {isTemplateLoading ? 
          <Loader /> : 
          <DataTable
            columns={columns}
            data={(predefinedTemplateList?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />}
      </div>
  )
}

export default Predefined